import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/admin-pages/admin.service';

interface CategoryParams {
  ID?: number;
  parentCategoryID: number;
  name: string;
  parentCategoryName: string;
  description: string;
  icon: string;
  sortOrder: number;
}

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss'],
})
export class AddCategoryComponent implements OnInit {
  // @Input sendingData
  @Output() closeModel = new EventEmitter<boolean>();
  @Input() isEditMode: boolean = false;
  @Input() currentCategory: any = null;
  @Output() categoryAdded =
    new EventEmitter<void>(); /* for onBoarding category add section*/

  categoryForm: FormGroup;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;

  loading: boolean = false;
  isShowDeletePopup: boolean = false;
  isShowAddForm: boolean = false;
  fileToUpload!: File; //uploading image

  constructor(private adminService: AdminService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.setForms();
    if (this.isEditMode && this.currentCategory) {
      this.populateForm();
    }
  }

  private setForms() {
    this.categoryForm = this.fb.group({
      name: ['', [Validators.required]],
      categoryImage: [''],
      sortOrder: []
    });
  }

  private populateForm() {
    this.categoryForm.patchValue({
      name: this.currentCategory.CategoryName,
      categoryImage: this.currentCategory.Icon,
      sortOrder: this.currentCategory.SortOrder,
    });
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 1000);
  }

  public addOrUpdateCategory() {
    this.categoryForm.markAllAsTouched();
    if (this.categoryForm.valid) {
      this.loading = true;
      const params: CategoryParams = {
        parentCategoryID: 0,
        name: this.categoryForm.value.name,
        parentCategoryName: '',
        description: '',
        icon: this.categoryForm.value.categoryImage,
        sortOrder: this.categoryForm.value.sortOrder
      };

      if (this.isEditMode) {
        params.ID = this.currentCategory.ID;
        this.updateCategory(params);
      } else {
        this.addCategory(params);
      }
    }
  }

  // API methods
  private addCategory(params: any) {
    this.adminService.addCategory(params).subscribe(
      (res: any) => {
        this.loading = false;
        if (res?.Result == 'Success' && res?.ResponseData == 'Success') {
          this.categoryForm.reset();
          this.closeModel.emit(true);
          this.categoryAdded.emit();
          this.notify(true, 'Category added successfully');
        } else if (res?.Result == 'Success' && res?.ResponseData == 'Already') {
          this.notify(false, 'Category already exist');
        } else {
          this.notify(false, 'Category adding failed');
        }
      },
      (error: HttpErrorResponse) => {
        this.loading = false;
        this.notify(false, 'Category adding failed');
      }
    );
  }

  private updateCategory(params: any) {
    this.adminService.updateCategory(params).subscribe(
      (res: any) => {
        this.loading = false;
        if (res?.Result == 'Success') {
          this.categoryForm.reset();
          this.closeModel.emit(true);
          this.isEditMode = false;
          this.notify(true, 'Category updated successfully');
        } else {
          this.notify(true, 'Category update failed');
        }
      },
      (error: HttpErrorResponse) => {
        this.loading = false;
        this.notify(true, 'Category update failed');
      }
    );
  }

  public clearFileUploader(formControlName: string) {
    this.categoryForm.get(formControlName)?.setValue(null);
  }

public uploadFile(event: any) {
  this.loading = true;
  const inputElement = event.target as HTMLInputElement;

  if (inputElement.files && inputElement.files[0]) {
    const fileToUpload = inputElement.files[0];
    const fileSizeInBytes = fileToUpload.size;
    const maxSizeInBytes = 500 * 1024;

    if (fileSizeInBytes > maxSizeInBytes) {
      this.notify(false, 'File size exceeds the limit of 500KB');
      this.loading = false;
      inputElement.value = '';
      return;
    }

    const extension = fileToUpload.name.split('.').pop();
    const sellerDetails = this.adminService.getLoginDetails();

    const formData = new FormData();
    formData.append('file', fileToUpload);
    formData.append('productId', '0');
    formData.append('sellerId', '0');
    formData.append('fileType', 'CategoryImage');
    formData.append('fileName', `${sellerDetails?.SellerName}_categoryimage`);

    this.adminService.uploadUsingFileStream(formData).subscribe(
      (res: any) => {
        this.loading = false;
        if (res?.Result === 'Success' && res.ResponseData) {
          this.categoryForm.get('categoryImage')?.setValue(res.ResponseData);
          this.notify(true, 'Uploaded successfully');
        } else {
          this.notify(false, 'Image upload failed');
        }
        inputElement.value = '';
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.notify(false, 'Image upload failed');
        inputElement.value = '';
      }
    );
  }
}

}
